import o from "styled-components";
import { transition as n, transform as g } from "../../../utils/css/animation.js";
import { margin as h, marginTop as r, marginBottom as f, marginLeft as m, marginRight as b, marginY as u, marginX as y, padding as S, paddingTop as c, paddingBottom as x, paddingLeft as R, paddingRight as w, paddingY as W, paddingX as v, borderRadius as T, borderTopLeftRadius as C, borderTopRightRadius as B, borderBottomLeftRadius as L, borderBottomRightRadius as k, borderWidth as s, borderBottomWidth as z, borderTopWidth as H, borderLeftWidth as j, borderRightWidth as A, gap as I, gridRowGap as X } from "../../../utils/css/layout.js";
import { hoverSupported as Y } from "../../../utils/css/mediaQueries.js";
import { textAlign as D, textDecoration as F, fontWeight as P, fontSize as V, lineHeight as E, textOverflow as G, whiteSpace as O, textTransform as K, letterSpacing as q, boxSizing as J, display as M, justifyContent as N, justifySelf as Q, justifyItems as U, alignItems as Z, alignSelf as _, flexDirection as p, flex as tt, flexWrap as it, position as et, top as dt, bottom as lt, left as at, right as $t, gridTemplateAreas as ot, gridTemplateColumns as nt, gridArea as gt, border as ht, borderColor as rt, borderStyle as ft, borderRightStyle as mt, borderBottomStyle as bt, boxShadow as ut, width as yt, maxWidth as St, minWidth as ct, height as xt, maxHeight as Rt, minHeight as wt, aspectRatio as Wt, cursor as vt, pointerEvents as Tt, overflowY as Ct, overflowX as Bt, overflow as Lt, webkitTapHighlightColor as kt, backgroundColor as st, background as zt, color as Ht, fill as jt, stroke as At, outline as It, zIndex as Xt, visibility as Yt, opacity as Dt, resize as Ft } from "../../../utils/css/other.js";
const i = (t) => `

${h(t.margin)}
${r(t.marginTop)}
${f(t.marginBottom)}
${m(t.marginLeft)}
${b(t.marginRight)}
${u(t.marginY)}
${y(t.marginX)}
${S(t.padding)}
${c(t.paddingTop)}
${x(t.paddingBottom)}
${R(t.paddingLeft)}
${w(t.paddingRight)}
${W(t.paddingY)}
${v(t.paddingX)}
${T(t.borderRadius)}
${C(t.borderTopLeftRadius)}
${B(t.borderTopRightRadius)}
${L(t.borderBottomLeftRadius)}
${k(t.borderBottomRightRadius)}
${s(t.borderWidth)}
${z(t.borderBottomWidth)}
${H(t.borderTopWidth)}
${j(t.borderLeftWidth)}
${A(t.borderRightWidth)}

${D(t.textAlign)}
${F(t.textDecoration)}
${P(t.fontWeight)}
${V(t.fontSize)}
${E(t.lineHeight)}
${G(t.textOverflow)}
${O(t.whiteSpace)}
${K(t.textTransform)}
${q(t.letterSpacing)}
${t.placeholderStyles ? `::placeholder{
    ${i(t.placeholderStyles)}
  }` : ""}

${J(t.boxSizing || "border-box")}
${M(t.display)}
${N(t.justifyContent)}
${Q(t.justifySelf)}
${U(t.justifyItems)}
${Z(t.alignItems)}
${_(t.alignSelf)}
${p(t.flexDirection)}
${tt(t.flex)}
${it(t.flexWrap)}
${et(t.position)}
${dt(t.top)}
${lt(t.bottom)}
${at(t.left)}
${$t(t.right)}
${ot(t.gridTemplateAreas)}
${nt(t.gridTemplateColumns)}
${gt(t.gridArea)}
${I(t.gap)}
${X(t.gridRowGap)}

${ht(t.border)}
${rt(t.borderColor)}
${ft(t.borderStyle)}
${mt(t.borderRightStyle)}
${bt(t.borderBottomStyle)}
${ut(t.boxShadow)}

${yt(t.width)}
${St(t.maxWidth)}
${ct(t.minWidth)}
${xt(t.height)}
${Rt(t.maxHeight)}
${wt(t.minHeight)}
${Wt(t.aspectRatio)}

${vt(t.cursor)}
${Tt(t.pointerEvents)}
${Ct(t.overflowY)}
${Bt(t.overflowX)}
${Lt(t.overflow)}
${kt(t.webkitTapHighlightColor)}

${st(t.backgroundColor)}
${zt(t.background)}
${Ht(t.color)}
${jt(t.fill)}
${At(t.stroke)}
${It(t.outline)}

${Xt(t.zIndex)}
${Yt(t.visibility)}  
${Dt(t.opacity)} 

${Ft(t.resize)}

${n(t.transition)}
${g(t.transform)}

${t.hoverStyles ? `:hover {
      ${Y(i(t.hoverStyles))}}` : ""}

${t.activeStyles ? `:active{
    ${i(t.activeStyles)}
  }` : ""}

${t.disabledStyles ? `:disabled{
    ${i(t.disabledStyles)}
  }` : ""}

${t.focusStyles ? `:focus{
    ${i(t.focusStyles)}
  }` : ""}

${t.focusWithinStyles ? `:focus-within{
    ${i(t.focusWithinStyles)}
  }` : ""}

${t.focusVisibleStyles ? `:focus-visible{
    ${i(t.focusVisibleStyles)}
  }` : ""}

${t.focusVisibleWithinStyles ? `:has(:focus-visible){
    ${i(t.focusVisibleWithinStyles)}
  }` : ""}

${t.firstChildStyles ? `:first-child{
    ${i(t.firstChildStyles)}
  }` : ""}

${t.lastChildStyles ? `:last-child{
    ${i(t.lastChildStyles)}
  }` : ""}

${t.allChildrenStyles ? `*{
    ${i(t.allChildrenStyles)}
  }` : ""}`, Pt = [
  "display",
  "width",
  "height",
  "top",
  "bottom",
  "left",
  "right",
  "cursor",
  "position"
], a = (t, e) => Pt.includes(t) ? !1 : e(t), qt = (t, e = {}) => o(t).withConfig({
  ...e,
  shouldForwardProp: (d, l) => e.shouldForwardProp ? e.shouldForwardProp(
    d,
    ($) => a($, l)
  ) : a(d, l)
})`
    ${i}
  `;
export {
  i as propsToStyles,
  qt as styledWithConfig
};
